import { render } from "./MyReceivedIOURequests.vue?vue&type=template&id=7a9a3e8c&scoped=true"
import script from "./MyReceivedIOURequests.vue?vue&type=script&lang=js"
export * from "./MyReceivedIOURequests.vue?vue&type=script&lang=js"

import "./MyReceivedIOURequests.vue?vue&type=style&index=0&id=7a9a3e8c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9a3e8c"]])

export default __exports__